export default __webpack_public_path__ + "static/media/placeBets.dbf5de4a.mp3";